import {Modal} from "@mantine/core";

export const CreateEditModal = props => {
    return (
        <Modal opened={props.open} onClose={props.close} title={props.modalTitle}>
            {props.children}
        </Modal>
    )
};
